import React, { useEffect, useState } from 'react';

const PASSOS = [
  'Acendendo as abóboras do castelo…',
  'Carregando os canhões dos tanques…',
  'Afiando o terreno da arena…',
  'Chamando os fantasmas da torcida…',
  'Contando as moedas do jackpot…',
  'Esquentando a sala de combinação…',
];

export const GbLoading = ({ progress = 0, resuming = false }) => {
  const [passo, setPasso] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setPasso((s) => (s + 1) % PASSOS.length), 1300);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center overflow-hidden bg-[#0b0712]"
      data-testid="gb-loading">
      <img src="/gb/duel_bg.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-45" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(255,107,0,.18),transparent_60%)]" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-[#0b0712]/70 to-[#0b0712]" />

      <div className="relative w-full max-w-md px-7 text-center">
        <p className="text-[10px] font-black uppercase tracking-[0.4em] text-orange-400/80">arena halloween</p>
        <h1 className="mt-2 text-4xl font-black leading-none tracking-tight text-amber-100 drop-shadow-[0_0_24px_rgba(255,140,0,.45)] sm:text-5xl">
          GB ARENA
        </h1>
        <p className="mt-2 text-xs font-bold text-purple-200/70">
          {resuming ? 'Voltando para a sua partida…' : PASSOS[passo]}
        </p>

        <div className="mt-7 h-3 overflow-hidden rounded-full border border-purple-800/70 bg-black/60"
          data-testid="gb-loading-bar">
          <div className="h-full rounded-full bg-gradient-to-r from-orange-600 via-orange-500 to-amber-300 transition-[width] duration-200"
            style={{ width: `${Math.max(4, Math.min(100, progress))}%` }} />
        </div>
        <p className="mt-2 font-mono text-sm font-black text-amber-300" data-testid="gb-loading-pct">
          {Math.min(100, Math.round(progress))}%
        </p>
        <p className="mt-6 text-[10px] leading-relaxed text-purple-300/50">
          Estamos baixando o mapa, os tanques e os efeitos agora para a partida não travar depois.
        </p>
      </div>
    </div>
  );
};
